import { FC } from 'react';
import { useTreeViewContext } from '../context/TreeViewContext';
import { useJsonViewModeContext } from '../context/JsonViewModeContext';
import {
  Branch as NestedTableBranch,
  Leaf as NestedTableLeaf,
  Root as NestedTableRoot,
} from '../nestedTable';
import { Branch as RawBranch, Leaf as RawLeaf, Root as RawRoot } from '../raw';
import { Branch as TableBranch, Leaf as TableLeaf, Root as TableRoot } from '../table';
import { ViewTypes } from '../types';

export enum ComponentTypes {
  root = 'root',
  branch = 'branch',
  leaf = 'leaf',
}

export type ComponentMapping = {
  [componentType in ComponentTypes]: {
    [viewType in ViewTypes]: FC<React.PropsWithChildren<any>>;
  };
};

export const useGetTreeComponent = (componentType: ComponentTypes) => {
  const { isRawJson } = useJsonViewModeContext();
  const { isNestedTable } = useTreeViewContext();

  let currViewType;
  if (isNestedTable) {
    currViewType = ViewTypes.nestedTable;
  } else if (isRawJson) {
    currViewType = ViewTypes.raw;
  } else {
    currViewType = ViewTypes.table;
  }

  const componentMapping: ComponentMapping = {
    [ComponentTypes.root]: {
      [ViewTypes.raw]: RawRoot,
      [ViewTypes.table]: TableRoot,
      [ViewTypes.nestedTable]: NestedTableRoot,
    },
    [ComponentTypes.branch]: {
      [ViewTypes.raw]: RawBranch,
      [ViewTypes.table]: TableBranch,
      [ViewTypes.nestedTable]: NestedTableBranch,
    },
    [ComponentTypes.leaf]: {
      [ViewTypes.raw]: RawLeaf,
      [ViewTypes.table]: TableLeaf,
      [ViewTypes.nestedTable]: NestedTableLeaf,
    },
  };

  return componentMapping[componentType][currViewType];
};
